import { API_BASE_URL } from "./apiConfig";

async function handleResponse(response) {
  if (response.status === 204) return null;
  const text = await response.text();
  const data = text ? JSON.parse(text) : null;
  if (!response.ok) {
    const message = (data && (data.message || data.error)) || `Request failed (${response.status})`;
    throw new Error(message);
  }
  return data;
}

function buildQuery(params) {
  const qs = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") qs.append(key, value);
  });
  const str = qs.toString();
  return str ? `?${str}` : "";
}

export async function generateReport(payload) {
  const response = await fetch(`${API_BASE_URL}/reports/generate/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
}

export async function listReports({ user_id, search, sort } = {}) {
  const response = await fetch(
    `${API_BASE_URL}/reports/${buildQuery({ user_id, search, sort })}`,
    { method: "GET" }
  );
  return handleResponse(response);
}

export async function getReport(id, user_id) {
  const response = await fetch(
    `${API_BASE_URL}/reports/${id}/${buildQuery({ user_id })}`,
    { method: "GET" }
  );
  return handleResponse(response);
}

export async function downloadReport(id, user_id) {
  const response = await fetch(
    `${API_BASE_URL}/reports/${id}/download/${buildQuery({ user_id })}`,
    { method: "GET" }
  );
  if (!response.ok) {
    const text = await response.text();
    let message = `Download failed (${response.status})`;
    try { const data = JSON.parse(text); message = data.message || message; } catch { /* ignore */ }
    throw new Error(message);
  }
  return response.blob();
}
